import {
  WSCard,
  WSInfoBox,
  WSList,
  WSPillProps
} from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";
import { InsuranceCoverageDataView } from "../../../../MyResources/components/InsuranceCoverageDataView";
import { RequirementContextType } from "../../../types";
import { useGoToMyResourceDetails } from "../../../../MyResources/paths";

type InsuranceCoverageMonitor =
  insuranceMonitorApiSpec.InsuranceCoverageMonitor;

type Props = {
  requirement: IRequirementResponse;
  insuranceCoverageMonitor: InsuranceCoverageMonitor;
  description: string;
  pill: WSPillProps;
  context: RequirementContextType;
  onDownloadClick?: () => void;
};
export const InsuranceCoverageDetails: React.FC<Props> = ({
  requirement,
  insuranceCoverageMonitor,
  description,
  pill,
  onDownloadClick,
  context
}) => {
  const goToView = useGoToMyResourceDetails();

  return (
    <WSList gap="L">
      <WSCard
        header={{
          label: "Policy information",
          value: {
            pill
          }
        }}
        actions={{
          alignment: "fill",
          buttons:
            context === RequirementContextType.Payer
              ? [
                  {
                    label: "View policy",
                    kind: "Secondary",
                    onClick() {
                      goToView(insuranceCoverageMonitor.insuranceCoverageId!);
                    }
                  }
                ]
              : onDownloadClick
              ? [
                  {
                    label: "View policy",
                    kind: "Secondary",
                    onClick: onDownloadClick
                  }
                ]
              : []
        }}
      >
        <WSList gap="XL" pb="L">
          <WSInfoBox>{description}</WSInfoBox>
          <InsuranceCoverageDataView
            insuranceCoverage={insuranceCoverageMonitor?.insuranceCoverage!}
          />
        </WSList>
      </WSCard>
    </WSList>
  );
};
